import { useQuery, UseQueryResult } from "@tanstack/react-query";
import useCrmRepository from "api/useCrmRepository";
import { getOnlineEvents } from "api/events/event.api";
import { OnlineEventItem } from "common/event/event.types";
import { twoMinutesInMs } from "@ic-anywhere/ic-dal";

export const getOnlineEventsQueryKey = ["getOnlineEvents"];

export const useGetOnlineEventsQuery = (): UseQueryResult<OnlineEventItem[]> => {
  const repo = useCrmRepository();

  return useQuery<OnlineEventItem[]>({
    queryKey: getOnlineEventsQueryKey,
    queryFn: () => getOnlineEvents(repo),
    enabled: true,
    gcTime: twoMinutesInMs,
  });
};
